import { Immutable } from "immer";
import React from "react";

import type { OprahModalBlock as OprahModalBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { OprahTitle } from "../OprahTitle";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: OprahModalBlockValue }>;

export const OprahModalBlock = (props: IProps): React.JSX.Element => {
    return (
        <div className={styles.oprahModalContent}>
            <img
                src={props.value.image?.url}
                className={concatClassNames([
                    styles.oprahModalImage,
                    "responsive",
                ])}
                alt="Exclusive Cocoon by Sealy Offer"
                loading="lazy"
                decoding="async"
            />
            <OprahTitle
                className={styles.oprahModalTitle}
                html={props.value.title ?? ""}
            />
            <div
                className={styles.oprahModalCopy}
                dangerouslySetInnerHTML={{ __html: props.value.copy ?? "" }}
            ></div>
            <div
                className={styles.oprahModuleCheckoutLink}
                dangerouslySetInnerHTML={{
                    __html: props.value.codeCopy ?? "",
                }}
            ></div>
            <div className={styles.oprahModalLink}>
                <div className="button button--secondary">Continue</div>
            </div>
        </div>
    );
};
